
export interface HandleWebhook200Response {
  message?: string;
  processedAt?: string;
  success?: boolean;
}
